import React, { useMemo, useState } from "react";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import { CreateWorkflowPreview } from "../../../Helper";

interface DropdownSelectorProps {
  selectorType: string;
  hideDefault?: boolean;
  selectorFn: (name: string) => void;
  selectedItem: string;
  activeItemData: any;
  switchSelectors?: () => void;
  disabledItem: string;
  sourceWorkflow?: string;
}

export const DropdownSelector = ({
  selectorType,
  selectorFn,
  selectedItem,
  activeItemData,
  hideDefault,
  switchSelectors,
  disabledItem,
  sourceWorkflow,
}: DropdownSelectorProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const styles = {
    borderRadius: "16px",
    background: menuOpen ? "var(--M-background95)" : "transparent",
    color: "var(--Main_icons_color)",
    opacity: menuOpen ? "0.7" : "1",
    border: menuOpen ? "1px solid #191B22" : "none",
    outline: "none",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-select": {
      padding: "8px 16px",
      border: "none",
    },
    "&.Mui-focused": {
      boxShadow: "none",
      border: "none",
    },
    "&:hover": {
      border: "none",
      background: "rgba(118, 207, 235, 0.05)",
      textDecoration: "none !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
    },
    "& .MuiSelect-icon": {
      color: "var(--Main_icons_color)",
      transform: menuOpen ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.3s ease",
    },
  };

  const handleOpen = () => {
    if (sourceWorkflow !== CreateWorkflowPreview) {
      setMenuOpen(true);
    }
  };

  const handleClose = () => setMenuOpen(false);
  const [currentSelected, setCurrentSelected] = useState("");

  const handleChange = (event: SelectChangeEvent) => {
    selectorFn(event.target.value);
    setCurrentSelected(event.target.value);
  };

  return (
    activeItemData.selectorOptions && (
      <FormControl
        sx={{
          my: 1,
          minWidth: 120,
          "@media (max-width: 500px)": {
            minWidth: "30%",
          },
        }}
      >
        <Select
          // disabled={sourceWorkflow === "createWorkflowPreview"}
          value={selectedItem}
          onChange={handleChange}
          displayEmpty
          renderValue={(value) =>
            value === "" ? activeItemData?.selectorTitle : value
          }
          onOpen={handleOpen}
          onClose={handleClose}
          open={menuOpen}
          IconComponent={KeyboardArrowDownIcon}
          inputProps={{ "aria-label": "Without label" }}
          sx={styles}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "var(--M-background95)",
                borderRadius: "16px",
                color: "var(--Main_icons_color)",
                fontSize: "12px !important",
                fontWeight: 500,
                maxHeight: "115px",
                overflowY: "auto",
                boxShadow: "none",
                "&::-webkit-scrollbar": {
                  width: "6px",
                  margin: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "var(--Main_icons_color)",
                  borderRadius: "10px",
                  margin: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                  margin: "8px",
                },
              },
            },
          }}
        >
          {activeItemData?.selectorOptions.map((lang: string, i: number) => (
            <MenuItem
              key={i}
              value={lang}
              sx={{
                fontSize: "12px",
                minHeight: "auto",
                display:
                  hideDefault && lang === "Detect language"
                    ? "none"
                    : disabledItem === lang
                    ? "none"
                    : "block",
                "&:hover": {
                  backgroundColor: "var(--m-background44)",
                  textDecoration: "none !important",
                },
                "&.Mui-selected": {
                  backgroundColor: "var(--M-background98)",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "var(--M-background98)",
                  textDecoration: "none !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>{lang}</span>
                {selectedItem === lang && (
                  <DoneIcon sx={{ fontSize: "14px" }} />
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  );
};
